export default __webpack_public_path__ + "static/media/BOD Regular Meeting 26 May 2021.60fecff0.pdf";